if (typeof window.themeObj.tools === 'undefined') {
  window.themeObj.tools = {
    money: (price) => {
      var currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
  
      if (!currencyFormat.includes('<span class="notranslate ht-money">')) {
        currencyFormat = `<span class="notranslate ht-money">${currencyFormat}</span>`;
  
        if (currencyFormat.includes('amount_with_comma_separator')) {
          currencyFormat = currencyFormat.replace(/amount\_with\_comma\_separator/, 'amount');
        }
      }
  
      const moneyText = (Number(price) / 100).toFixed(2);
      
      const newCurrencyFormat = currencyFormat.replace(/\{\{amount\}\}/, moneyText);
      return newCurrencyFormat;
    },
    insertAfter: function(referenceNode, newNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    },
    formToJson: function(elements) {
      return [].reduce.call(elements, function (data, element) {
        data[element.name] = element.value;
        return data;
      }, {});
    },
    getUrlString: function(data) {
      var urlParameters = Object.entries(data).map(function (e) {
        return e.join('=');
      }).join('&');
    
      return urlParameters;
    },
    getUrlParameter: function(sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
  
      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
  
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    }
  };
}

window.themeObj.templates.product = {
  inited: false,
  init: () => {
    const obj = window.themeObj.templates.product;
    
    obj.timer.init();
    obj.form.init();
    
    obj.sizeGuide();
    
    obj.gallery();
    
    new obj.sizes();
    new obj.bundle();
    obj.inited = true
  },
  // timer: {
  //   init: function() {
  //     const timer = document.querySelector('.ProductForm__Timer');
    
  //     if (timer) {
  //       window.themeObj.templates.product.timer.refresh();
    
  //       setInterval(function() {
  //         window.themeObj.templates.product.timer.refresh();
  //       }, 1000);
  //     }
  //   },
  //   refresh: function() {
  //     const timer = document.querySelector('.ProductForm__Timer');
  //     const timerTime = timer.querySelector('b');
    
  //     const timeNow = Date.now();
    
  //     if (localStorage.getItem('productTimerEnd')) {
  //       var timerTimeEnd = parseInt(localStorage.getItem('productTimerEnd'));
  //     } else {
  //       var min = 60 * 60 * 2;
  //       var max = 60 * 60 * 6;
    
  //       var timerTimeEnd = timeNow + (Math.floor(Math.random() * (max - min) + min)) * 1000;
  //       localStorage.setItem('productTimerEnd', timerTimeEnd);
  //     }
    
  //     var timeDifference = timerTimeEnd - timeNow;
  //     if (timeDifference > 0) {
  //       let newTimerTimeText;
  //       newTimerTimeText = timeDifference;
    
  //       var timerHours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //       var timerMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  //       var timerSeconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
  //       timerTime.innerHTML = (timerHours < 10 ? '0' : '') + timerHours + ':' + (timerMinutes < 10 ? '0' : '') + timerMinutes + ':' + (timerSeconds < 10 ? '0' : '') + timerSeconds;
  //       timer.classList.add('Active');
  //     } else {
  //       localStorage.removeItem('productTimerEnd'); 
  //     }
  //   }
    
  // },
  timer: {
  init: function() {
    const timer = document.querySelector('.ProductForm__Timer');
    if (!timer) return;

    let timerTime = timer.querySelector('b');
    if (!timerTime) {
      const span = timer.querySelector('.ProductForm__TimerText');
      timerTime = document.createElement('b');
      timerTime.style.marginLeft = '5px';
      timerTime.textContent = '00:00:00';
      span.appendChild(timerTime);
    }

    window.themeObj.templates.product.timer.refresh();

    setInterval(function() {
      window.themeObj.templates.product.timer.refresh();
    }, 1000);
  },

  refresh: function() {
    const timer = document.querySelector('.ProductForm__Timer');
    if (!timer) return;

    const timerTime = timer.querySelector('b');
    if (!timerTime) return;

    const now = new Date();

    let endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23, 59, 59, 999
    );

    // endOfDay.setDate(endOfDay.getDate() + 1);

  let diff = endOfDay - now;

  if (diff <= 0) {
    endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      23, 59, 59, 999
    );
    diff = endOfDay - now;
  }

  // const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  const hours = Math.floor(
    (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );

  const minutes = Math.floor(
    (diff % (1000 * 60 * 60)) / (1000 * 60)
  );

  const seconds = Math.floor(
    (diff % (1000 * 60)) / 1000
  );

  timerTime.textContent =
    (hours   < 10 ? '0' : '') + hours   + ':' +
    (minutes < 10 ? '0' : '') + minutes + ':' +
    (seconds < 10 ? '0' : '') + seconds;

    timer.classList.add('Active');
  }
},

  form: {
    init: () => {
      const sizes = document.querySelector('.ProductForm__Sizes');
  
      if (sizes) {
        sizes.classList.add('Active');
      }
      
      window.themeObj.templates.product.form.allButtons();
      window.themeObj.templates.product.form.colorButtons();
      window.themeObj.templates.product.form.sizeButtons();
    
      window.themeObj.templates.product.form.additionalProductVariants();

      const imageVariant = document.querySelector(`.ProductForm__SizesItems__Options.Active > .ProductForm__SizesItems__OptionsList > .ProductForm__SizesItems__Option[data-type="image"]`);
  
      if (!imageVariant) {
        window.themeObj.templates.product.refresh('button');
        
      } else {
        window.themeObj.templates.product.refresh('image');
      }
    },
    allButtons: () => {
      const sizesItems = document.querySelectorAll('.ProductForm__SizesItem');
    
      if (sizesItems) {
    
        for (var i = 0; i < sizesItems.length; i++) {
          const sizesItem = sizesItems[i];
          const sizesItemProductSource = sizesItem.getAttribute('data-product-source');
          const sizesItemProductId = sizesItem.getAttribute('data-product-id');
          
          sizesItem.addEventListener('click', function() {
            
            if (!sizesItem.classList.contains('Active')) {
              const form = sizesItem.closest('form');
              const bundleItems = form.querySelectorAll('bundle-item');
              bundleItems.forEach(bundleItem => {
                  // if (bundleItem.getAttribute('data-product-id') === sizesItemProductId) {
                  //     bundleItem.classList.remove('item--hidden');
                  // } else {
                  //     if (!bundleItem.classList.contains('item--hidden')) {
                  //         bundleItem.classList.add('item--hidden');
                  //     }
                  // }
              });
              const activeSizesItem = sizesItem.parentNode.querySelector('.ProductForm__SizesItem.Active');
              activeSizesItem.classList.remove('Active');
              
              sizesItem.classList.add('Active');
  
              const productTitle = document.querySelector('.ProductMeta__Title');
              productTitle.innerHTML = sizesItem.getAttribute('data-product-title');
    
              const productVariants = document.querySelector('.ProductForm__Variants');
              
              const options = document.querySelectorAll('.ProductForm__SizesItems__Options[data-product-id="' + sizesItemProductId + '"]');
              const activeOptions = document.querySelectorAll('.ProductForm__SizesItems__Options.Active');
              
              for (var i2 = 0; i2 < activeOptions.length; i2++) {
                activeOptions[i2].classList.remove('Active');
              }
              
              for (var i2 = 0; i2 < options.length; i2++) {
                options[i2].classList.add('Active');
              }
  
              window.themeObj.templates.product.refresh('image');
            }
          });
        }
      }
    },
    colorButtons: () => {
      const optionsColors = document.querySelectorAll('.ProductForm__SizesItems__Option[data-type="image"].Active');
    
      if (optionsColors) {
    
        for (var i = 0; i < optionsColors.length; i++) {
          const optionsColor = optionsColors[i];
          const optionsColorValue = optionsColor.getAttribute('data-value');
    
          const title = optionsColor.parentNode.parentNode.querySelector('.ProductForm__SizesItems__OptionsTitle > span');
  
          if (title) {
            title.innerHTML = optionsColorValue;
          }
        }
      }
    },
    sizeButtons: () => {
      const optionsItems = document.querySelectorAll('.ProductForm__SizesItems__Option');
      
      if (optionsItems) {
    
        for (var i = 0; i < optionsItems.length; i++) {
          const optionsItem = optionsItems[i];
          
          optionsItem.addEventListener('click', function() {
            const optionsItemValue = optionsItem.getAttribute('data-value');
            const optionsItemType = optionsItem.getAttribute('data-type');
            
            const optionsItemProductSource = optionsItem.getAttribute('data-product-source');
  
            if (optionsItemProductSource != 'upsell' && !optionsItem.classList.contains('Active')) {
              const optionsActiveItem = optionsItem.parentNode.querySelector('.ProductForm__SizesItems__Option.Active');
    
              if (optionsActiveItem) {
                optionsActiveItem.classList.remove('Active');
              }
              
              optionsItem.classList.add('Active');
      
              if (optionsItemType == 'image') {
                const title = optionsItem.parentNode.parentNode.querySelector('.ProductForm__SizesItems__OptionsTitle > span');
  
                if (title) {
                  title.innerHTML = optionsItemValue;
                }
              }

              const productTitle = document.querySelector('.ProductMeta__Title');
              if(productTitle && optionsItem.getAttribute('data-product-title')){
                productTitle.innerHTML = optionsItem.getAttribute('data-product-title');
              }
                
              window.themeObj.templates.product.refresh(optionsItemType);
            }
          });
        }
      }
    },
    additionalProductVariants: () => {
      const optionsButtons = document.querySelectorAll('.ProductForm__SizesItems__Option[data-type="button"][data-product-source="children"]');
  
      if (optionsButtons) {
  
        for (var i = 0; i < optionsButtons.length; i++) {
          const optionsButton = optionsButtons[i];
          const optionsButtonValue = optionsButton.getAttribute('data-value');
  
          const originalOptionsButton = optionsButton.parentNode.querySelector(`.ProductForm__SizesItems__Option[data-type="button"][data-product-source="main"][data-value="${optionsButtonValue}"]`);
  
          if (originalOptionsButton) {
            // const originalOptionsButtonImageId = originalOptionsButton.getAttribute('data-image-id');
            // optionsButton.setAttribute('data-image-id', originalOptionsButtonImageId);
            
            // originalOptionsButton.after(optionsButton);
          }
        }
      }
    }
  },
  gallery: () => {
    const images = document.querySelectorAll('.Product__Gallery .Product__SlideshowNav .Product__SlideshowNavImage');

    if (!images.length) {
      return false;
    }
  
    images.forEach((image) => {
    
      image.addEventListener('click', () => {
        const imageMediaId = image.getAttribute('data-media-id');

        const galleryContainer = image.closest('.Product__GalleryContainer');
        
        const cover = galleryContainer.querySelector(`.Product__SlideItem[data-media-id="${imageMediaId}"]`);
        const coverI = cover.getAttribute('tabindex');
        
        const source = galleryContainer.getAttribute('data-product-source');
    
        if (source != 'main') {
          const slider = galleryContainer.querySelector('.Product__Slideshow');
          var flkty = new Flickity(slider);
          flkty.select(coverI);
          
          const navSlider = galleryContainer.querySelector('.Product__SlideshowNavScroller');
          var flkty = new Flickity(navSlider);
          flkty.select(coverI);
        }
      });
    });

    return;

    

    images.forEach((image) => {

      image.addEventListener('click', function() {
        const image = this;

        const imageI = Array.prototype.indexOf.call(image.parentNode.children, image);

        const galleryContainer = image.closest('.Product__GalleryContainer');
        const source = galleryContainer.getAttribute('data-product-source');

        if (source !== 'main') {
          const slider = galleryContainer.querySelector('.Product__Slideshow');
          var flkty = new Flickity(slider);
          flkty.select(imageI);

          const navSlider = galleryContainer.querySelector('.Product__SlideshowNavScroller');
          var flktyNav = new Flickity(navSlider);
          flktyNav.select(imageI);
        }
      });
    });
  },
  bundle: class {

    data = {
      wrapper: document.querySelector('.ProductBundle')
    }

    constructor() {
      const obj = this;

      const wrapper = document.querySelector('.ProductBundle');

      if (wrapper) {
        obj.items();
        obj.loadFormOptions();
        obj.addToCart();
      }
    }

    items() {
      const obj = this;
      
      const items = document.querySelectorAll('.ProductBundle__Item');

      if (items.length) {

        for (var i = 0; i < items.length; i++) {
          const item = items[i];
          
          /* /Heading bg */
          const itemHeadingBg = item.querySelector('.ProductBundle__ItemHeading__Bg');
          
          itemHeadingBg.addEventListener('click', () => {
            const itemHeading = itemHeadingBg.parentNode;
            const item = itemHeading.parentNode;

            if (item.classList.contains('is-active')) {
              item.classList.remove('is-active');
              
            } else {
              const activeItem = item.parentNode.querySelector('.ProductBundle__Item.is-active');

              if (activeItem) {
                activeItem.classList.remove('is-active');
              }
              
              item.classList.add('is-active');
              obj.loadFormOptions();
            }
          });
          /* /Heading bg */

          /* Heading options */
          const itemHeadingOptions = item.querySelectorAll('.ProductBundle__ItemHeading__Option');

          if (itemHeadingOptions.length) {
            
            for (var i2 = 0; i2 < itemHeadingOptions.length; i2++) {
              const itemHeadingOption = itemHeadingOptions[i2];
    
              itemHeadingOption.addEventListener('click', () => {
                const activeItemHeadingOption = itemHeadingOption.parentNode.querySelector('.ProductBundle__ItemHeading__Option.is-active');
                activeItemHeadingOption.classList.remove('is-active');
                
                itemHeadingOption.classList.add('is-active');
                const itemHeadingOptionProductHandle = itemHeadingOption.getAttribute('data-product-handle');

                const itemFormOptions = itemHeadingOption.parentNode.parentNode.parentNode.parentNode.querySelector(`.ProductBundle__ItemForm__Options[data-product-handle="${itemHeadingOptionProductHandle}"]`);
                
                const activeItemFormOptions = itemFormOptions.parentNode.querySelector('.ProductBundle__ItemForm__Options.is-active');
                activeItemFormOptions.classList.remove('is-active');
                
                itemFormOptions.classList.add('is-active');

                obj.loadFormOptions();
              });
            }
          }
          /* /Heading options */
        }
      }
    }

    loadFormOptions() {
      const obj = this;
      
      const item = document.querySelector('.ProductBundle__Item.is-active');
      const itemFormOptions = item.querySelector('.ProductBundle__ItemForm__Options.is-active');
      
      const itemFormOptionsProductHandle = itemFormOptions.getAttribute('data-product-handle');
      
      const url = `/products/${itemFormOptionsProductHandle}?section_id=product-bundle`;
      
      const activeItemFormOptions = itemFormOptions.parentNode.querySelector('.ProductBundle__ItemForm__Options.is-active');
      
      if (activeItemFormOptions) {
        activeItemFormOptions.classList.remove('is-active');
      }
      
      itemFormOptions.classList.add('is-active');
      
      if (itemFormOptions.classList.contains('is-loaded')) {
        obj.variantChange();

      } else {
        
        fetch(url)
          .then(response => response.text())
          .then(response => {
            const fetchContent = new DOMParser()
              .parseFromString(response, 'text/html');
            
            const fetchItemFormOptions = fetchContent.querySelector('.ProductBundle__ItemForm__Options');
            itemFormOptions.innerHTML = fetchItemFormOptions.innerHTML;
      
            /* Gallery */
            const galleries = document.querySelector('.Product__GalleryWrapper');
            const fetchGalleries = fetchContent.querySelectorAll('.Product__GalleryContainer');

            if (galleries &&
                fetchGalleries.length) {

              for (var i = 0; i < fetchGalleries.length; i++) {
                const fetchGallery = fetchGalleries[i];
                const fetchGalleryProductHandle = fetchGallery.getAttribute('data-product-handle');
                
                const gallery = document.querySelector(`.Product__GalleryContainer[data-product-handle="${fetchGalleryProductHandle}"]`);

                if (!gallery) {
                  galleries.append(fetchGallery);
                }
              }
            }
            /* /Gallery */
            
            const itemFormOptionsItems = itemFormOptions.querySelectorAll('.ProductBundle__ItemForm__OptionItem');
      
            if (itemFormOptionsItems.length) {
            
              for (var i = 0; i < itemFormOptionsItems.length; i++) {
                const itemFormOptionsItem = itemFormOptionsItems[i];

                itemFormOptionsItem.addEventListener('click', () => {
                  const itemFormOptionsItemType = itemFormOptionsItem.getAttribute('data-type');
                  const itemFormOptionsItemValue = itemFormOptionsItem.getAttribute('data-value');

                  const item = itemFormOptionsItem.closest('.ProductBundle__Item');
                  const itemFormOption = itemFormOptionsItem.closest('.ProductBundle__ItemForm__Option');
                  
                  const itemFormOptionValue = itemFormOption.querySelector('.ProductBundle__ItemForm__OptionValue');
                  itemFormOptionValue.innerHTML = itemFormOptionsItemValue;
                  
                  switch (itemFormOptionsItemType) {

                    case 'image':
                      item.classList.remove('is-valid');

                      /* Gallery */
                      const imageId = itemFormOptionsItem.getAttribute('data-image-id');
                  
                      if (imageId) {
                        const image = document.querySelector(`.Product__SlideItem[data-image-id="${imageId}"]`);
                  
                        if (image) {
                          const productId = image.getAttribute('data-product-id');
                          const imageI = image.getAttribute('data-i');
                    
                          const activeGalleryContainer = document.querySelector('.Product__GalleryContainer.Active');
                          
                          if (activeGalleryContainer) {
                            activeGalleryContainer.classList.remove('Active');
                          }
                      
                          const galleryContainer = image.closest('.Product__GalleryContainer');
                          galleryContainer.classList.add('Active');
                          
                          const gallery = galleryContainer.querySelector('.Product__Slideshow');
                  
                          if (typeof Flickity !== 'undefined') {
                  
                            if (gallery.classList.contains('flickity-enabled')) {
                              var flkty = new Flickity(gallery);
                              
                            } else {
                              const flktyData = {
                                "prevNextButtons": true,
                                "pageDots": true,
                                "draggable": true,
                                "contain": true,
                                "adaptiveHeight": true,
                                "watchCSS": true,
                                "dragThreshold": 8,
                                "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
                              };
                              var flkty = new Flickity(gallery, flktyData);
                            }
                            
                            flkty.select(imageI);
                            
                            if (!gallery.offsetHeight) {
                              flkty.resize();
                            }
                  
                            const slider = galleryContainer.querySelector('.Product__SlideshowNavScroller');
                            
                            if (slider) {
                              const flktyData = {
                                "adaptiveHeight": true,
                                "prevNextButtons": true,
                                "contain": true,
                                "draggable": true,
                                "asNavFor": `.Product__GalleryContainer.Active .Product__Slideshow`,
                                "cellAlign": "left"
                              };
                              var flkty = new Flickity(slider, flktyData);
                  
                              flkty.select(imageI);
                  
                              if (!slider.offsetHeight) {
                                flkty.resize();
                              }
                            }
                          }
                        }
                      }
                      /* /Gallery */

                      break;
                      
                    case 'button':
                      
                      if (itemFormOptionsItem.classList.contains('is-sold-out')) {
                        item.classList.add('is-invalid');
                        item.classList.remove('is-valid');
                        
                      } else {
                        const nextItem = item.nextElementSibling;
            
                        if (nextItem) {
                          const nextItemHeadingBg = nextItem.querySelector('.ProductBundle__ItemHeading__Bg');
                        //   nextItemHeadingBg.click();
                        }

                        // item.classList.remove('is-active');

                        item.classList.remove('is-invalid');
                        item.classList.add('is-valid');
                      }

                      break;
                  }

                  const activeItemFormOptionsItems = itemFormOptionsItem.parentNode.querySelectorAll('.is-active');
                  
                  if (activeItemFormOptionsItems.length) {

                    for (var i2 = 0; i2 < activeItemFormOptionsItems.length; i2++) {
                      const activeItemFormOptionsItem = activeItemFormOptionsItems[i2];
                      activeItemFormOptionsItem.classList.remove('is-active');
                    }
                  }

                  itemFormOptionsItem.classList.add('is-active');
                  obj.variantChange();

                  switch (itemFormOptionsItemType) {

                    case 'image':

                      /* Button */
                      const itemFormNextOption = itemFormOption.nextElementSibling;

                      if (itemFormNextOption) {
                        const itemNextOptionButton = itemFormNextOption.querySelector(`.ProductBundle__ItemForm__OptionItem.is-active:not(.is-hidden)[data-type="button"]`);
          
                        if (!itemNextOptionButton) {
                          const itemFormNextOptionValue = itemFormNextOption.querySelector('.ProductBundle__ItemForm__OptionValue');
                          const itemFormNextOptionValueText = itemFormNextOptionValue.innerHTML.trim();

                          const itemFormNextOptionButton = itemFormNextOption.querySelector(`.ProductBundle__ItemForm__OptionItem[data-type="button"][data-option1="${itemFormOptionsItemValue}"][data-value="${itemFormNextOptionValueText}"]`);
                          
                          if (itemFormNextOptionButton) {
                            itemFormNextOptionButton.click();
                          
                          } else {
                            itemFormNextOptionValue.innerHTML = '';
                          }
                        }
                      }
                      /* /Button */
                      break;
                  }
                });
              }
            }

            const itemsFormOptionsImage = itemFormOptions.querySelector('.ProductBundle__ItemForm__OptionItem[data-type="image"]');

            if (itemsFormOptionsImage) {
              itemsFormOptionsImage.click();
            }
      
            obj.variantChange();
      
            itemFormOptions.classList.add('is-loaded');
          });
      }
    }

    variantChange() {
      const obj = this;
      
      const itemsFormOptionsImage = document.querySelector('.ProductBundle__Item.is-active .ProductBundle__ItemForm__Options.is-active .ProductBundle__ItemForm__OptionItem[data-type="image"].is-active');

      if (itemsFormOptionsImage) {
        // itemsFormOptionsImage.click();
      }
      
      const items = document.querySelectorAll('.ProductBundle__Item');
      
      if (items) {
        
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
          const itemOptions = item.querySelector('.ProductBundle__ItemForm__Options.is-active');

          const itemImage = itemOptions.querySelector(`.ProductBundle__ItemForm__OptionItem.is-active[data-type="image"]`);

          if (itemImage) {
            const itemImageValue = itemImage.getAttribute('data-value');

            /* Button */
            const itemOptionButtons = itemOptions.querySelectorAll(`.ProductBundle__ItemForm__OptionItem[data-type="button"]`);
  
            for (var i2 = 0; i2 < itemOptionButtons.length; i2++) {
              const itemOptionButton = itemOptionButtons[i2];
              const itemOptionButtonOption1 = itemOptionButton.getAttribute('data-option1');
  
              if (itemOptionButtonOption1 == itemImageValue) {
                itemOptionButton.classList.remove('is-hidden');
                
              } else {
                itemOptionButton.classList.add('is-hidden');
              }
            }

            /* Item heading */
            const itemHeadingValue = item.querySelector('.ProductBundle__ItemHeading__Value');
            var itemHeadingValueText = '';
            
            const itemFormOptionItems = itemOptions.querySelectorAll('.ProductBundle__ItemForm__OptionItem.is-active');
  
            for (var i2 = 0; i2 < itemFormOptionItems.length; i2++) {
              const itemFormOptionItem = itemFormOptionItems[i2];
              const itemFormOptionItemValue = itemFormOptionItem.getAttribute('data-value');
  
              if (i2) {
                itemHeadingValueText += ' / ';
              }
  
              itemHeadingValueText += itemFormOptionItemValue;
            }

            itemHeadingValue.setAttribute('data-value', itemHeadingValueText);
          }
          /* /Item heading */
        }
      }
    }

    addToCart() {
      const obj = this;
      
      const button = document.querySelector('.ProductForm__AddToCart');

      if (button) {

        button.addEventListener('click', () => {
          const items = document.querySelectorAll('.ProductBundle__Item');
    
          if (items.length) {
            var formData = {
              items: []
            };

            var upsellVariantId;
            var upsellVariantPropertyIds = [];
            
            if (obj.data.wrapper.hasAttribute('data-upsell-variant-id')) {
              upsellVariantId = obj.data.wrapper.getAttribute('data-upsell-variant-id');
            }
          
            for (var i = 0; i < items.length; i++) {
              const item = items[i];

              if (item.classList.contains('is-valid')) {
                const itemVariantId = item.querySelector('.ProductBundle__ItemForm__Options.is-active .ProductBundle__ItemForm__OptionItem.is-active[data-type="button"]').getAttribute('data-variant-id');

                var itemPropertyIds = [];

                if (upsellVariantId) {
                  itemPropertyIds.push(upsellVariantId);
                  upsellVariantPropertyIds.push(itemVariantId);
                }

                if (i) {
                  const prevItemFormOptionsButton = items[0].querySelector('.ProductBundle__ItemForm__Options.is-active .ProductBundle__ItemForm__OptionItem.is-active[data-type="button"]');
                  
                  if (prevItemFormOptionsButton) {
                    const prevItemVariantId = prevItemFormOptionsButton.getAttribute('data-variant-id');
                    itemPropertyIds.push(prevItemVariantId);
                  }
                  
                } else {
                  const nextItemFormOptionsButton = items[1].querySelector('.ProductBundle__ItemForm__Options.is-active .ProductBundle__ItemForm__OptionItem.is-active[data-type="button"]');

                  if (nextItemFormOptionsButton) {
                    const nextItemVariantId = nextItemFormOptionsButton.getAttribute('data-variant-id');
                    itemPropertyIds.push(nextItemVariantId);
                  }
                }

                formData.items.unshift({
                  id: itemVariantId,
                  quantity: 1,
                  properties: {
                    _bundle: '✓',
                    _ids: itemPropertyIds.join(',')
                  }
                });

              } else {
                item.classList.add('is-invalid');
              }
            }

            if (upsellVariantId) {
              formData.items.unshift({
                id: upsellVariantId,
                quantity: 1,
                properties: {
                  _bundle: '✓',
                  _ids: upsellVariantPropertyIds.join(',')
                }
              });
            }
          }

          if (formData.items.length == 3) {
            button.setAttribute('disabled', 'disabled');

            fetch("".concat(window.routes.cartAddUrl, ".js"), {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => {
              
              if (response.ok) {
                button.removeAttribute('disabled');
  
                document.dispatchEvent(new CustomEvent('product:added', {
                  detail: {
                    quantity: 1
                  }
                }));
              }
            });
          }
        });
      }
    }
  },
  
  sizes: class {

    constructor() {
      const obj = this;

      const wrapper = document.querySelector('.ProductForm__Sizes');

      if (wrapper) {
        obj.socksUpsell();
        obj.priorityProccessingUpsell();
      }
    }

    socksUpsell() {
      window.themeObj.templates.product.sizesUpsell.init();
    }

    priorityProccessingUpsell() {
      const upsell = document.querySelector('.ProductForm__Upsell');
  
      if (!upsell) {
        return false;
      }
      
      const upsellVariantId = upsell.getAttribute('data-variant-id');
  
      document.addEventListener('theme:priorityProccessingUpsell:add', (event) => {
        
        fetch('/cart/add.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: upsellVariantId,
            properties: {
              _upsell: '✓'
            },
            quantity: 1
          })
        })
          .then((response) => {
          
            if (!response.ok) {
              return false;
            }
            
            return response.json();
        })
          .then((response) => {
            const event2Name = 'product:added';
            const event2 = new CustomEvent(event2Name, {
              bubbles: true,
              detail: {
                upsellAdded: true,
                variant: {
                  id: upsellVariantId
                },
                quantity: 1
              }
            });
            document.dispatchEvent(event2);
        });
      });
  
      document.addEventListener('theme:cart:rendered', (event) => {
        const cartItem = document.querySelector(`#sidebar-cart .CartItem[data-product-type="upsell"][data-variant-id="${upsellVariantId}"]`);
  
        if (!cartItem) {
          return false;
        }
  
        if (event.detail.cartResult.items == 1) {
          const cartRecommended = document.querySelector('.CartDrawer__Recommended');
  
          if (cartRecommended) {
            cartRecommended.style.display = 'none';
          }
          
          const cartItemDelete = cartItem.querySelector('.CartItem__Remove');
          cartItemDelete.click();
        }
      });
    }
  },
  
  sizesUpsell: {
    init: function() {
      const upsellOptions = document.querySelectorAll('.ProductForm__SizesItems__Option[data-type="image"][data-product-source="upsell"]');
  
      for (var i = 0; i < upsellOptions.length; i++) {
        const upsellOption = upsellOptions[i];
        const upsellOptionImage = upsellOption.querySelector('.ProductForm__SizesItems__OptionImage');
  
        upsellOptionImage.addEventListener('click', function() {
          const upsellOption = this.parentNode;
          
          const upsellOptionActiveVariant = upsellOption.querySelector('.ProductForm__SizesItems__OptionPopup__Variant.Active');
  
          if (upsellOptionActiveVariant) {
            const upsellOptionActiveVariantImageId = upsellOptionActiveVariant.getAttribute('data-image-id');
            window.themeObj.templates.product.refreshGallery(upsellOptionActiveVariantImageId);
          }
          
          if (upsellOption.classList.contains('Opened')) {
            window.themeObj.templates.product.sizesUpsell.closePopup(upsellOption);
          
          } else {
            window.themeObj.templates.product.sizesUpsell.openPopup(upsellOption);
          }
        });
  
        const upsellOptionClose = upsellOption.querySelector('.ProductForm__SizesItems__OptionPopup__Close');
        
        upsellOptionClose.addEventListener('click', function() {
          window.themeObj.templates.product.sizesUpsell.closePopup(upsellOption);
        });
    
        const upsellOptionBg = upsellOption.querySelector('.ProductForm__SizesItems__OptionPopup__Bg');

        /* vDEV */
        document.addEventListener('theme:product__variantUpsell:close', () => {

          if (!upsellOption.classList.contains('Opened')) {
            return false;
          }
          
          window.themeObj.templates.product.sizesUpsell.closePopup(upsellOption);
        });
        /* /vDEV */
        
        upsellOptionBg.addEventListener('click', function() {
          window.themeObj.templates.product.sizesUpsell.closePopup(upsellOption);
        });
  
        const upsellOptionButton = upsellOption.querySelector('.Button');
  
        upsellOptionButton.addEventListener('click', function() {
          window.themeObj.templates.product.sizesUpsell.addToCart(upsellOptionButton);
        });
  
        const upsellOptionVariants = upsellOption.querySelectorAll('.ProductForm__SizesItems__OptionPopup__Variant');
        
        for (var i2 = 0; i2 < upsellOptionVariants.length; i2++) {
          const upsellOptionVariant = upsellOptionVariants[i2];
          
          upsellOptionVariant.addEventListener('click', function() {
            const upsellOptionVariant = this;
            const upsellOptionActiveVariant = upsellOptionVariant.parentNode.querySelector('.Active');
    
            if (upsellOptionActiveVariant) {
              upsellOptionActiveVariant.classList.remove('Active');
            }
            
            upsellOptionVariant.classList.add('Active');

            if (upsellOptionButton.classList.contains('Added')) {
              upsellOptionButton.removeAttribute('disabled');
              upsellOptionButton.classList.remove('Added');
              upsellOptionButton.querySelector('span').innerHTML = upsellOptionButton.getAttribute('data-add_to_cart');
            }
            
            const upsellOptionVariantImageId = upsellOptionVariant.getAttribute('data-image-id');
            window.themeObj.templates.product.refreshGallery(upsellOptionVariantImageId);
          });
        }
      }

      /* vDEV */
      window.themeObj.templates.product.sizesUpsell.elements();
      /* /vDEV */
    },

    /* vDEV */
    elements: () => {

      class ProductVariantUpsellPopupBg extends HTMLElement {

        constructor() {
          super();
          
          const obj3 = this;

          obj3.addEventListener('click', () => {
            const event = new CustomEvent('theme:product__variantUpsell:close');
            document.dispatchEvent(event);
          });
        }
      }
      
      customElements.define('product-variant-upsell-popup-bg', ProductVariantUpsellPopupBg);

      class ProductVariantUpsellPopup extends HTMLElement {

        constructor() {
          super();

          const obj3 = this;

          obj3.events();
        }

        events() {
          const obj3 = this;
          
          window.addEventListener('scroll', () => {
            obj3.scroll();
          });

          document.addEventListener('theme:product__variantUpsell:opened', () => {
            obj3.scroll();
          });
        }

        scroll() {
          const obj3 = this;
          
          const upsellButton = obj3.parentNode;

          if (!upsellButton.classList.contains('Opened')) {
            return false;
          }
          
          const upsellButtonReact = upsellButton.getBoundingClientRect();
          
          const upsellPopupReact = obj3.getBoundingClientRect();
          let upsellPopupPosition;
          
          const scrollTop = document.querySelector('html').scrollTop;
          
          if (upsellButtonReact.top + 20 + obj3.offsetHeight > scrollTop + window.innerHeight) {
            upsellPopupPosition = 'top';

          } else {
            upsellPopupPosition = 'bottom';
          }

          obj3.setAttribute('data-popup-position', upsellPopupPosition);
        }
      }
      
      customElements.define('product-variant-upsell-popup', ProductVariantUpsellPopup);
    },
    /* /vDEV */
    
    openPopup: function(upsellOption) {
      document.body.classList.add('ProductUpsellPopup--opened');
      upsellOption.classList.add('Opened');

      /* vDEV */
      const productVariantUpsellPopupBg = document.createElement('product-variant-upsell-popup-bg');
      document.querySelector('.Product__Wrapper').append(productVariantUpsellPopupBg);
      /* vDEV */
          
      if (window.screen.width < 1140) {
        const upsellOptionActiveVariantScroll = document.querySelector('.ProductForm__SizesItems__OptionPopup__Scroll');
        upsellOptionActiveVariantScroll.scrollIntoView({
            behavior: 'smooth',
            block: 'end'
        });
      }

      var upsellOption = document.querySelector('.ProductForm__SizesItems__Option.Opened');
      const upsellOptionButton = upsellOption.querySelector('.ProductForm__SizesItems__OptionPopup .Button');

      if (upsellOptionButton.classList.contains('Added')) {
        upsellOptionButton.removeAttribute('disabled');
        upsellOptionButton.classList.remove('Added');
        upsellOptionButton.querySelector('span').innerHTML = upsellOptionButton.getAttribute('data-add_to_cart');
      }
      
      /* Main variant */
      const activeOption = upsellOption.parentNode.querySelector('.ProductForm__SizesItems__Option.Active');
      const activeOptionUpsellId = activeOption.getAttribute('data-upsell-variant-id');

      const upsellOptionActiveVariant = upsellOption.querySelector('.ProductForm__SizesItems__OptionPopup__Variant.Active');

      if (upsellOptionActiveVariant) {
        upsellOptionActiveVariant.classList.remove('Active');
      }
      
      const upsellOptionVariant = upsellOption.querySelector('.ProductForm__SizesItems__OptionPopup__Variant[data-variant-id="' + activeOptionUpsellId + '"]');

      if (upsellOptionVariant) {
        upsellOptionVariant.classList.add('Active');
        
        const upsellOptionVariantImageId = upsellOptionVariant.getAttribute('data-image-id');
        window.themeObj.templates.product.refreshGallery(upsellOptionVariantImageId);
      }
      
      const eventName = 'theme:product__variantUpsell:opened';
      const event = new CustomEvent(eventName, {
        detail: {
          upsell: upsellOption
        }
      });

      document.dispatchEvent(event);
    },
    closePopup: function(upsellOption) {
      upsellOption.classList.remove('Opened');
      document.body.classList.remove('ProductUpsellPopup--opened');
      
      /* vDEV */
      const productVariantUpsellPopupBg = document.querySelector('product-variant-upsell-popup-bg');

      if (productVariantUpsellPopupBg) {
        productVariantUpsellPopupBg.remove();
      }
      /* vDEV */
       
      window.themeObj.templates.product.refresh('image');
    },
    addToCart: function(upsellOptionButton) {
      upsellOptionButton.setAttribute('disabled', 'disabled');

      const upsellOption = upsellOptionButton.parentNode.parentNode;
      const upsellOptionActiveVariantId = upsellOption.querySelector('.ProductForm__SizesItems__OptionPopup__Variant.Active').getAttribute('data-variant-id');

      const formData = {
        id: upsellOptionActiveVariantId,
        quantity: 1
      };
      
      fetch("".concat(window.routes.cartAddUrl, ".js"), {
        body: JSON.stringify(formData),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        
        if (response.ok) {
          upsellOption.classList.add('Added');
          
          upsellOptionButton.classList.add('Added');
          upsellOptionButton.querySelector('span').innerHTML = upsellOptionButton.getAttribute('data-added');
  
          setTimeout(function() {
            document.dispatchEvent(
              new CustomEvent('upsell:added')
            );
          }, 100);  
        }
      });
    }
  },

  sizeGuide: () => {

    setTimeout(() => {
      const formSizeGuide = document.querySelector('.ProductForm .size-chart');
      const descriptionSizeImage = document.querySelector('.desc-meta-wrapper.img-size > .desc-img > p');
  
      if (formSizeGuide && descriptionSizeImage) {
        const formSizeGuideCloned = formSizeGuide.cloneNode(true);
        window.themeObj.tools.insertAfter(descriptionSizeImage, formSizeGuideCloned);
  
        formSizeGuideCloned.querySelector('.size_pop').addEventListener('click', function() {
          formSizeGuide.querySelector('.size_pop').click();
        });
      }
    }, 500);
  },
  
  scroll: () => {
  
    if (window.screen.width >= 1008) {
      const st = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      const activeGallery = document.querySelector('.Product__Sizes-Item__Gallery.Active');
  
      if (activeGallery) {
        const activeGalleryItems = activeGallery.querySelectorAll('.Product__Slideshow .Product__SlideItem');
  
        if (activeGalleryItems) {
          var activeGalleryItemDotFound = false;
  
          for (var i = 0; i < activeGalleryItems.length; i++) {
            const activeGalleryItem = activeGalleryItems[i];
            const activeGalleryItemDot = activeGallery.querySelector('.Product__SlideshowNavDot:nth-child(' + (i + 1) + ')');
            
            if (activeGalleryItem.offsetTop >= st + document.querySelector('.AnnouncementBar').offsetHeight + document.querySelector('.Header__Wrapper').offsetHeight) {
  
            } else {
              const activeGalleryItemActiveDots = activeGalleryItemDot.parentNode.querySelectorAll('.is-selected');
  
              if (activeGalleryItemActiveDots) {
                
                for (var i2 = 0; i2 < activeGalleryItemActiveDots.length; i2++) {
                  activeGalleryItemActiveDots[i2].classList.remove('is-selected');
                }
              }
  
              activeGalleryItemDot.classList.add('is-selected');
            }
          }
        }
      }
    }
  },
  
  refreshPrices: (variant) => {
    const addToCartPrice = document.querySelector('.Product .Product__Info .ProductForm__AddToCart .ht-money');

    if (addToCartPrice) {
      addToCartPrice.innerHTML = window.themeObj.tools.money(variant.price);
    }

    const metaPriceList = document.querySelector('.ProductMeta__PriceList');

    if (metaPriceList) {
      metaPriceList.innerHTML = '';

      if (variant.compare_at_price > variant.price) {
        metaPriceList.innerHTML += `<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>${window.themeObj.tools.money(variant.compare_at_price)}</span>`;
        metaPriceList.innerHTML += `<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>${window.themeObj.tools.money(variant.price)}</span>`;
        
        const metaPriceAlert = document.querySelector('.ProductMeta__PriceList').getAttribute('data-alert');

        const priceDifference = variant.compare_at_price - variant.price;
        var discountPercent = parseInt(100 - (variant.price / variant.compare_at_price * 100));
        discountPercent = Math.ceil(discountPercent / 10) * 10;
        metaPriceList.innerHTML += `<span class="ProductMeta__Price--alert">${metaPriceAlert.replace(/\{\{ percent \}\}/, discountPercent).replace(/\{\{ price \}\}/, window.themeObj.tools.money(priceDifference))}</span>`;
        
      } else {
        metaPriceList.innerHTML += `<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>${window.themeObj.tools.money(variant.price)}</span>`;
      }
    }
  },
  refresh: (optionsActiveButtonType) => {
    const optionsLists = document.querySelectorAll('.ProductForm__SizesItems__OptionsList');

    if (optionsLists) {
      
      for (var i = 0; i < optionsLists.length; i++) {
        const optionsList = optionsLists[i];

        if (optionsList.querySelector('.ProductForm__SizesItems__Option[data-type="image"]')) {
          optionsList.setAttribute('data-type', 'image');
        }
      }
    }
    
    const options = document.querySelector('.ProductForm__SizesItems__Options.Active');

    if (options) {
      var activeOption = options.querySelector('.ProductForm__SizesItems__Option[data-type="image"].Active');

      if (!activeOption) {
        activeOption = options.querySelector('.ProductForm__SizesItems__Option.Active');

        /* Check if the size button is available */
        if (optionsActiveButtonType == 'image') {
          const activeSizeButton = document.querySelector(`.ProductForm__SizesItems__Options.Active > .ProductForm__SizesItems__OptionsList > .ProductForm__SizesItems__Option[data-type="${optionsActiveButtonType}"].Visible.Available.Active`);
          
          if (!activeSizeButton) {
            var newActiveSizeButton = document.querySelector(`.ProductForm__SizesItems__Options.Active > .ProductForm__SizesItems__OptionsList > .ProductForm__SizesItems__Option[data-type="${optionsActiveButtonType}"].Visible.Available`);
          
            if (!newActiveSizeButton) {
              var newActiveSizeButton = document.querySelector(`.ProductForm__SizesItems__Options.Active > .ProductForm__SizesItems__OptionsList > .ProductForm__SizesItems__Option[data-type="${optionsActiveButtonType}"].Visible`);
            }
            
            if (newActiveSizeButton) {
              newActiveSizeButton.click();
            }
          }
          /* /Check if the size button is available */
          
          activeOption = options.querySelector('.ProductForm__SizesItems__Option[data-type="image"].Active');
        }
      }

      const optionsProductId = activeOption.getAttribute('data-product-id');
      
      const optionsInput = document.querySelector('.ProductForm__SizesItems__OptionsWrapper > input[name="id"]');
      optionsInput.value = '';
  
      const optionsItemsJson = document.querySelector('.ProductForm__SizesItems__OptionsWrapper script[data-product-id="' + optionsProductId + '"]');
      const optionsItems = JSON.parse(optionsItemsJson.innerHTML);
      
      var optionsActiveButtonValue = '';
      var optionsActiveButtonImageId = '';
      
      /* Active buttons */
      const optionsButtons = document.querySelectorAll('.ProductForm__SizesItems__Options.Active .ProductForm__SizesItems__Option.Active');

      const productTitle = document.querySelector('.ProductMeta__Title');
      if(productTitle && optionsButtons[0].getAttribute('data-product-title')){
        productTitle.innerHTML = optionsButtons[0].getAttribute('data-product-title');
      }
  
      if (optionsButtons) {
    
        for (var i = 0; i < optionsButtons.length; i++) {
          const optionsButton = optionsButtons[i];
          const optionsButtonType = optionsButton.getAttribute('data-type');
          const optionsButtonValue = optionsButton.getAttribute('data-value');
          
          const optionsButtonProductId = optionsButton.getAttribute('data-product-id');
          const optionsButtonProductSource = optionsButton.getAttribute('data-product-source');
    
          if (i) {
            optionsActiveButtonValue += ' / ';
          }
    
          optionsActiveButtonValue += optionsButtonValue;
  
          if (optionsButtonType == 'button') {
            
            for (var i2 = 0; i2 < optionsItems.length; i2++) {
              const optionsItem = optionsItems[i2];
              
              if (optionsActiveButtonValue == optionsItem.title) {
                optionsInput.value = optionsItem.id;
                window.themeObj.templates.product.refreshPrices(optionsItem);
              }
              
              if (optionsActiveButtonImageId == '' &&
                  
                  // typeof optionsItem.available !== 'undefined' &&
                  // optionsItem.available &&
                  
                  optionsItem.option1 == optionsButtons[0].getAttribute('data-value') &&
                  
                  typeof optionsItem.featured_image !== 'undefined' &&
                  optionsItem.featured_image &&
                  
                  typeof optionsItem.featured_image.id !== 'undefined') {
                optionsActiveButtonImageId = optionsItem.featured_image.id;
              }
            }
            
            if (optionsButtonProductSource == 'children') {
              const optionsItemsJson = document.querySelector('.ProductForm__SizesItems__OptionsWrapper script[data-product-id="' + optionsButtonProductId + '"]');

              if (optionsItemsJson) {
                const optionsItems = JSON.parse(optionsItemsJson.innerHTML);
              
                for (var i2 = 0; i2 < optionsItems.length; i2++) {
                  const optionsItem = optionsItems[i2];
                  
                  if (optionsActiveButtonValue == optionsItem.title) {
                    optionsInput.value = optionsItem.id;
                    window.themeObj.templates.product.refreshPrices(optionsItem);
                  }
                  
                  if (optionsActiveButtonImageId == '' &&
                      
                      // typeof optionsItem.available !== 'undefined' &&
                      // optionsItem.available &&
                      
                      optionsItem.option1 == optionsButtons[0].getAttribute('data-value') &&
                      
                      typeof optionsItem.featured_image !== 'undefined' &&
                      optionsItem.featured_image &&
                      
                      typeof optionsItem.featured_image.id !== 'undefined') {
                    optionsActiveButtonImageId = optionsItem.featured_image.id;
                  }
                }
              }
            }
          }
        }
      }
      /* /Active buttons */
  
      /* All buttons */
      if (optionsLists.length > 1) {
        var inactiveOptionsButtons = document.querySelectorAll('.ProductForm__SizesItems__Options.Active + .ProductForm__SizesItems__Options.Active .ProductForm__SizesItems__Option');
      
      } else {
        var inactiveOptionsButtons = document.querySelectorAll('.ProductForm__SizesItems__Options.Active .ProductForm__SizesItems__Option');
      }
      
      if (inactiveOptionsButtons) {
        const form = document.querySelector('.ProductForm');
        form.classList.remove('SoldOut');
        
        for (var i = 0; i < inactiveOptionsButtons.length; i++) {
          const inactiveOptionsButton = inactiveOptionsButtons[i];
          const inactiveOptionsButtonValue = inactiveOptionsButton.getAttribute('data-value');

          const inactiveOptionsButtonProductSource = inactiveOptionsButton.getAttribute('data-product-source');
          const inactiveOptionsButtonProductId = inactiveOptionsButton.getAttribute('data-product-id');
  
          inactiveOptionsButton.classList.remove('Visible');
          inactiveOptionsButton.classList.remove('Available');

          if (inactiveOptionsButtonProductSource == 'children') {
            const optionsItemsJson = document.querySelector('.ProductForm__SizesItems__OptionsWrapper script[data-product-id="' + inactiveOptionsButtonProductId + '"]');
            const optionsItems = JSON.parse(optionsItemsJson.innerHTML);

            for (var i2 = 0; i2 < optionsItems.length; i2++) {
              const optionsItem = optionsItems[i2];

              if (optionsItem.option1 == optionsButtons[0].getAttribute('data-value') &&
                  (
                    (optionsLists.length > 1 && optionsItem.option2 == inactiveOptionsButtonValue) ||
                    optionsLists.length == 1
                  )) {
                inactiveOptionsButton.classList.add('Visible');

                if (typeof optionsItem.available !== 'undefined' &&
                  optionsItem.available) {
                  inactiveOptionsButton.classList.add('Available');
                }
              }
            }
          
          } else if (inactiveOptionsButtonProductId == optionsProductId) {
            
            for (var i2 = 0; i2 < optionsItems.length; i2++) {
              const optionsItem = optionsItems[i2];

              if (optionsItem.option1 == optionsButtons[0].getAttribute('data-value') &&
                  (
                    (optionsLists.length > 1 && optionsItem.option2 == inactiveOptionsButtonValue) ||
                    optionsLists.length == 1
                  )) {
                inactiveOptionsButton.classList.add('Visible');

                if (typeof optionsItem.available !== 'undefined' &&
                  optionsItem.available) {
                  inactiveOptionsButton.classList.add('Available');
                }
              }
            }
          }
  
          if (!inactiveOptionsButton.classList.contains('Available') && inactiveOptionsButton.classList.contains('Active')) {
            form.classList.add('SoldOut');
          }
        }
      }
      /* /All buttons */
      
      /* Check if the size button is available */
      if (optionsActiveButtonType == 'image') {
        const activeSizeButton = document.querySelector('.ProductForm__SizesItems__Options.Active > .ProductForm__SizesItems__OptionsList > .ProductForm__SizesItems__Option[data-type="button"].Visible.Available.Active');
        
        if (!activeSizeButton) {
          var newActiveSizeButton = document.querySelector('.ProductForm__SizesItems__Options.Active > .ProductForm__SizesItems__OptionsList > .ProductForm__SizesItems__Option[data-type="button"].Visible.Available');
        
          if (!newActiveSizeButton) {
            var newActiveSizeButton = document.querySelector('.ProductForm__SizesItems__Options.Active > .ProductForm__SizesItems__OptionsList > .ProductForm__SizesItems__Option[data-type="button"].Visible');
          }
          
          if (newActiveSizeButton) {
            newActiveSizeButton.click();
          }
        }
      }
      /* /Check if the size button is available */

      if (typeof optionsActiveButtonType !== 'undefined' &&
          optionsActiveButtonType == 'image' &&
          optionsActiveButtonImageId) {
        window.themeObj.templates.product.refreshGallery(optionsActiveButtonImageId);
      }
    }
  },
  refreshGallery: (imageId) => {

    if (imageId) {
      const image = document.querySelector('.Product__SlideItem[data-image-id="' + imageId + '"]');

      if (image) {
        const imageI = image.getAttribute('data-i');

        const source = image.getAttribute('data-product-source');
        var productId = image.getAttribute('data-product-id');
  
        const activeGalleryContainer = document.querySelector('.Product__GalleryContainer.Active');
        
        if (activeGalleryContainer) {
          activeGalleryContainer.classList.remove('Active');
        }
    
        var galleryContainer = image?.closest(".Product__GalleryContainer")

        if (!galleryContainer) {
          var alternativeGalleryContainer = document.querySelector('.Product__GalleryContainer[data-product-source="' + source + '"]');
          var productId = alternativeGalleryContainer.getAttribute('data-product-id');
          var galleryContainer = alternativeGalleryContainer;
        }

        galleryContainer.classList.add('Active');
        
        const gallery = galleryContainer.querySelector('.Product__Slideshow');

        if (typeof Flickity !== 'undefined') {

          if (gallery.classList.contains('flickity-enabled')) {
            var flkty = new Flickity(gallery);
            
          } else {
            var flktyData = {
              "prevNextButtons": true,
              "pageDots": true,
              "draggable": true,
              "contain": true,
              "adaptiveHeight": true,
              "watchCSS": true,
              "dragThreshold": 8,
              "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
            };
            var flkty = new Flickity(gallery, flktyData);
          }
          
          window.themeObj.templates.product.inited && flkty.select(imageI);
          
          if (!gallery.offsetHeight) {
            flkty.resize();
          }

          const slider = galleryContainer.querySelector('.Product__SlideshowNavScroller');
          
          if (slider) {
            var flktyData = {
              "adaptiveHeight": true,
              "prevNextButtons": true,
              "contain": true,
              "draggable": true,
              "asNavFor": `.Product__GalleryContainer[data-product-source="${source}"][data-product-id="${productId}"] .Product__Slideshow`,
              "cellAlign": "left"
            };
            var flkty = new Flickity(slider, flktyData);

            window.themeObj.templates.product.inited && flkty.select(imageI);

            if (!slider.offsetHeight) {
              flkty.resize();
            }
          }
        }
      }
    }
  }
};

if (document.body.classList.contains('template-product')) {
  window.themeObj.templates.product.init();
}